/* TorLux™ cart-drawer upsell: delegated handlers survive Shopify section refreshes. */
(function () {
  'use strict';
  if (window.TorLuxDrawerUpsellInitialized) return;
  window.TorLuxDrawerUpsellInitialized = true;

  // The original cart-drawer-items component treats every bubbled change as
  // a cart quantity change. Intercept only upsell select changes in capture phase.
  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches('[data-torlux-upsell-variant]')) return;
    event.stopPropagation();
    const select = event.target;
    const card = select.closest('[data-torlux-upsell-card]');
    if (!card || select.tagName !== 'SELECT') return;
    const option = select.selectedOptions[0];
    if (!option) return;
    const price = card.querySelector('[data-torlux-upsell-price]');
    const compare = card.querySelector('[data-torlux-upsell-compare]');
    const image = card.querySelector('[data-torlux-upsell-image]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (image && option.dataset.image) image.src = option.dataset.image;
  }, true);

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-torlux-upsell-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;

    const card = button.closest('[data-torlux-upsell-card]');
    const variantField = card && card.querySelector('[data-torlux-upsell-variant]');
    const variantId = variantField && Number(variantField.value);
    const errorElement = card && card.querySelector('[data-torlux-upsell-error]');
    const label = button.querySelector('[data-torlux-upsell-button-label]');
    if (!variantId) return;
    if (errorElement) { errorElement.textContent = ''; errorElement.hidden = true; }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Wird hinzugefügt …';

    let addCompleted = false;
    let cartUrl = '/cart';
    try {
      const drawer = document.querySelector('cart-drawer');
      const sectionNames = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (entry) { return entry.id; })
        : ['cart-drawer', 'cart-icon-bubble'];
      const cartAddUrl = window.routes && window.routes.cart_add_url
        ? window.routes.cart_add_url
        : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add';
      cartUrl = window.routes && window.routes.cart_url
        ? window.routes.cart_url
        : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionNames,
          sections_url: window.location.pathname
        })
      });
      const cartData = await response.json();
      if (!response.ok || cartData.status) {
        throw new Error(cartData.description || cartData.message || 'Dieser Artikel konnte nicht hinzugefügt werden.');
      }
      addCompleted = true;

      // Re-render the original cart drawer and bubble through the theme's
      // native integration, keeping quantities, discounts, totals and checkout.
      if (drawer && typeof drawer.renderContents === 'function') {
        let renderedSections = cartData.sections;
        if (!renderedSections || !sectionNames.every(function (name) { return renderedSections[name]; })) {
          const url = new URL(cartUrl, window.location.origin);
          url.searchParams.set('sections', sectionNames.join(','));
          const sectionsResponse = await fetch(url.toString());
          if (!sectionsResponse.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
          renderedSections = await sectionsResponse.json();
        }
        if (!renderedSections || !sectionNames.every(function (name) { return renderedSections[name]; })) {
          throw new Error('Warenkorb konnte nicht aktualisiert werden.');
        }
        drawer.renderContents({ id: variantId, sections: renderedSections });
      } else {
        // Any alternative cart mode still receives a correct, non-stale cart.
        window.location.assign(cartUrl);
      }
    } catch (error) {
      if (addCompleted) {
        // Added successfully, but section rendering failed: never invite a
        // duplicate second add. Navigate to the refreshed cart instead.
        window.location.assign(cartUrl);
        return;
      }
      if (errorElement) {
        errorElement.textContent = error.message || 'Bitte versuche es erneut.';
        errorElement.hidden = false;
      }
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = button.dataset.label || 'Hinzufügen';
      }
    }
  });
})();
